<template>
  <div>
    <!-- <div style="margin-top: 20px">
      <el-button @click="test">Test Click</el-button>
    </div>-->
    <el-table
      ref="table"
      :data="data"
      row-key="MenuId"
      border
      stripe
      default-expand-all
    >
      <el-table-column type="index" align="center" width="45">
        <template #header>
          <el-checkbox
            v-model="topRow.Checked"
            @change="handleAllSelect(topRow.Checked)"
          ></el-checkbox>
        </template>
        <template slot-scope="{ row }">
          <el-checkbox
            v-model="row.Checked"
            @change="handleSelect(row)"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        label="菜单名称"
        :width="$store.state.isMB ? '100px' : ''"
      >
        <template slot-scope="{ row }">{{ row.MenuName }}</template>
      </el-table-column>
      <el-table-column :width="$store.state.isMB ? '310px' : '400px'">
        <template #header>
          <el-checkbox
            v-for="(chk, $index) in topRow.MenuFuncs"
            :key="$index"
            class="_checkbox"
            v-model="chk.Checked"
            :disabled="!topRow.Checked"
            @change="handleFuncAllSelect(chk, $index)"
            >{{ chk.FuncName }}</el-checkbox
          >
        </template>
        <template slot-scope="{ row }">
          <el-checkbox
            v-for="(chk, $index) in row.MenuFuncs"
            :key="$index"
            class="_checkbox"
            v-model="chk.Checked"
            :disabled="!row.Checked"
            @change="handleFuncSelect(row, chk, $index)"
            >{{ chk.FuncName }}</el-checkbox
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
// import api from "@/api/sys/role";
export default {
  data() {
    return {
      data: [],
      sourceData: [],
      topRow: {
        Checked: false,
        MenuFuncs: [
          {
            MenuFuncId: 0,
            FuncName: "浏览",
            Checked: false,
          },
          {
            MenuFuncId: 1,
            FuncName: "添加",
            Checked: false,
          },
          {
            MenuFuncId: 2,
            FuncName: "修改",
            Checked: false,
          },
          {
            MenuFuncId: 3,
            FuncName: "删除",
            Checked: false,
          },
          {
            MenuFuncId: 4,
            FuncName: "审核",
            Checked: false,
          },
          // {
          //   MenuFuncId: 3,
          //   FuncName: "二级审核",
          //   Checked: false,
          // },
        ],
        children: this.data,
      },
    };
  },
  methods: {
    test() {
      // console.log(this.data);
      // console.log(this.sourceData);
      // console.log(this.getCheckedRows());
    },
    handleFuncSelect(row, item, index) {
      if (row.Pid != 0) {
        this.setParent(row.Pid, index);
      }
      if (row.children) {
        this.setChild(row.children, item.Checked, index);
      }
      if (this.topRow.MenuFuncs[index]) {
        this.topRow.MenuFuncs[index].Checked = this.sourceData.some((item) => {
          if (item.MenuFuncs[index]) {
            return item.MenuFuncs[index].Checked == true;
          }
        });
      }

      if (index == 0) {
        row.Checked = item.Checked;
        this.handleSelect(row, 1);
      }
    },
    handleFuncAllSelect(val, index) {
      this.setChild(this.data, val.Checked, index);
      if (val.FuncName != "浏览") {
        return;
      }
      this.handleAllSelect(val.Checked, 1);
    },
    handleSelect(row, state = 0) {
      if (row.Pid != 0) {
        this.setParent(row.Pid);
      }
      if (row.children) {
        this.setChild(row.children, row.Checked);
      }
      console.log(row, "aa");
      this.topRow.Checked = this.sourceData.some(
        (item) => item.Checked == true
      );
      let func = row.MenuFuncs.find((x) => x.FuncName == "浏览");
      func.Checked = row.Checked;
      if (state == 0) {
        this.handleFuncSelect(row, func, 0);
      } else {
      }
    },
    handleAllSelect(val, state = 0) {
      this.setChild(this.data, val);
      let func = this.topRow.MenuFuncs.find((x) => x.FuncName == "浏览");
      func.Checked = val;
      if (state == 0) {
        this.handleFuncAllSelect(func, 0);
      } else {
        this.topRow.Checked = val;
      }
    },
    setParent(pid, index) {
      let parent = this.sourceData.find((item) => item.MenuId == pid);
      console.log(parent, "parent", this.sourceData);
      if (parent) {
        if (index != undefined) {
          console.log(parent.MenuFuncs[index], "aa");
          if (parent.MenuFuncs[index]) {
            parent.MenuFuncs[index].Checked = parent.children.some((s) => {
              if (s.MenuFuncs[index]) {
                return s.MenuFuncs[index].Checked == true;
              }
            });
          }

          if (parent.Pid != 0) {
            this.setParent(parent.Pid, index);
          }
        } else {
          parent.Checked = parent.children.some((s) => s.Checked == true);
          if (parent.Pid != 0) {
            this.setParent(parent.Pid);
          }
        }
      }
    },
    setChild(data, value, index) {
      if (index != undefined) {
        data.forEach((item) => {
          if (item.MenuFuncs[index]) {
            item.MenuFuncs[index].Checked = value;
          }
          if (item.children) {
            this.setChild(item.children, value, index);
          }
        });
      } else {
        data.forEach((item) => {
          item.Checked = value;
          if (item.children) {
            this.setChild(item.children, value);
          }
        });
      }
    },
    setData(menus) {
      console.log(menus);
      this.topRow.Checked = menus.some((item) => item.Checked == true);
      this.topRow.MenuFuncs.forEach((item, index) => {
        item.Checked = menus.some((item) => {
          if (item.MenuFuncs[index]) {
            return item.MenuFuncs[index].Checked == true;
          }
        });
      });
      this.sourceData = menus;
      this.data = this.$commonJs.toTreeData(menus, "MenuId");
      console.log(this.data, "aaa", this.sourceData);
    },
    getCheckedRows() {
      let checkedRow = this.sourceData.filter((item) => item.Checked == true);
      return checkedRow;
    },
    reset() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>
<style scoped>
._checkbox {
  margin-right: 10px;
}
</style>